import { useState } from "react";
import { AlertTriangle, Copy, Check } from "lucide-react";
import { toast } from "sonner";

const SEVERITY_STYLES = {
  high: "border-sovereign/50 bg-sovereign/10",
  medium: "border-warning-amber/40 bg-warning-amber/10",
  low: "border-surface-border bg-surface-card",
};

export const HallucinationWarningCard = ({ warning, index }) => {
  const [copied, setCopied] = useState(false);
  const severity = warning.severity || "medium";

  const copyTruth = async () => {
    const text = warning.truth_statement || "";
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      toast.success("Truth Statement copied - paste it on your site or socials.");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error("Could not copy automatically - please select and copy the text manually.");
    }
  };

  return (
    <div
      className={`rounded-lg border p-5 fade-up ${SEVERITY_STYLES[severity] || SEVERITY_STYLES.medium} glow-sovereign`}
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`hallucination-warning-card-${index}`}
    >
      <div className="mb-2 flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-sovereign" />
        <span className="text-xs font-bold uppercase tracking-widest text-sovereign">Hallucination Warning</span>
        <span className="ml-auto rounded-full border border-sovereign/40 px-2 py-0.5 text-[10px] font-semibold uppercase text-sovereign">
          {severity}
        </span>
      </div>
      <p className="mb-2 font-heading text-base font-semibold text-white" data-testid={`hallucination-claim-${index}`}>{warning.claim}</p>
      <p className="mb-4 text-sm text-slate-400">{warning.why_wrong}</p>
      <div className="rounded-md border border-truth-green/30 bg-truth-green/5 p-3">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-truth-green">Truth Statement Generator</p>
        <p className="mb-3 text-sm text-slate-200">{warning.truth_statement}</p>
        <button
          onClick={copyTruth}
          className="flex items-center gap-2 rounded-md border border-truth-green/40 px-3 py-1.5 text-xs font-medium text-truth-green transition-colors hover:bg-truth-green/10"
          data-testid={`copy-truth-statement-btn-${index}`}
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          {copied ? "Copied" : "Copy to fix signal"}
        </button>
      </div>
    </div>
  );
};
